module.exports = __webpack_public_path__ + "img/sq2.27771b8a.png";